var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "a",
      {
        staticClass: "link_item",
        attrs: { href: _vm.cafeUrl, target: "_blank" },
      },
      [
        _c("div", { staticClass: "thumb_g" }, [
          _c("img", {
            attrs: {
              src: _vm.profileImage,
              width: "40",
              height: "40",
              alt: "",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "desc_item" }, [
          _c("strong", { staticClass: "tit_item" }, [
            _vm._v(_vm._s(_vm.starName)),
          ]),
          _vm._v(" "),
          _vm.official
            ? _c("span", { staticClass: "ico_cafetop ico_emblum" }, [
                _vm._v("공식"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("ul", { staticClass: "list_info" }, [
            _c("li", [_vm._v("랭킹 " + _vm._s(_vm.rank))]),
            _vm._v(" "),
            _c("li", [
              _vm._v("회원 " + _vm._s(_vm.memberCount.toLocaleString())),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }